import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UserSettingsProfiloLPComponent } from './gestione-profilo-lp';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.gestione-profilo-lp', {
            url: '/gestione-profilo-LP',
            views: {
                'userContent': {
                    template: '<gestione-profilo-lp></gestione-profilo-lp>'
                }
            },
            ncyBreadcrumb: {
                label: 'Utente',
                parent: 'usersettings.index'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Utente'
            },
            resolve: {
                user: ($q, $rootScope, store: ng.a0.storage.IStoreService, UserService) => {
                    let email = $rootScope.currentUser().sub === undefined ? store.get('user').accountData.email : $rootScope.currentUser().sub;
                    return UserService.getUser(email)
                        .then((result) => {
                            return result;
                        }, (error) => {
                            return $q.reject(error);
                        });
                }
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneProfiloLPModule: string = ng
    .module('gestione-profilo-lp', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .component('gestioneProfiloLp', UserSettingsProfiloLPComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/sections/usersettings/gestione-profilo-lp/gestione-profilo-lp.module.ts